<ng-container *ngIf="showItem">
  <label [for]="idItem">
    <p-checkbox
      class="checkbox"
      (onChange)="onCheckboxChange()"
      [(ngModel)]="status"
      binary="true"
      [inputId]="idItem"
    ></p-checkbox>
    <p [ngClass]="{ isActive: status }">
      {{ status ? labelInput.on : labelInput.off }}
    </p>
  </label>
</ng-container>

